import Vue from 'vue'
import Search from './search.vue'
import i18n from '../locale/index';

import store from './store'

new Vue({
  i18n,
  el: document.querySelector('#search'),
  store,
  render: h => h(Search),
 })